<template>
  <div class="selects" ref="dropdown" @click="openSelect()">
    <p class="title" :class="{ active: selects }">{{ title }}</p>
    <ul class="list disf" ref="dropdownCont">
      <li
        v-for="(item, index) in option"
        @click="handleClickSlideEvent(item)"
        class="textSpace"
        :class="{ 'active': selects, 'justone': option.length === 1 }"
        :key="index"
        :title="item.label"
      >
        {{ item.label }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {
      selects: false,
    };
  },
  props: {
    option: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "请选择",
    },
  },
  methods: {
    openSelect() {
      this.selects = !this.selects;
      let h = Math.ceil(this.option.length / 4);
      if (this.selects) {
        this.$refs.dropdownCont.style.display = "flex";
        setTimeout(() => {
          this.$refs.dropdownCont.style.height = `${h * 52}px`;
        });
      } else {
        this.$refs.dropdownCont.style.height = 0;
        setTimeout(() => {
          this.$refs.dropdownCont.style.display = "none";
        }, 500);
      }
    },
    handleClickSlideEvent(item) {
      this.$emit("callback", item.value);
    },
    handleClickOutside(event) {
      // 如果点击的不是 dropdown 这个元素本身或其内部
      if (!this.$refs.dropdown.contains(event.target)) {
        this.selects = false;
        this.$refs.dropdownCont.style.height = 0;
        setTimeout(() => {
          this.$refs.dropdownCont.style.display = "none";
        }, 500);
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>


<style scoped lang="less">
.selects {
  background: transparent;
  border: 1px solid #ffffff;
  border-radius: 6px;
  color: #252933;

  padding: 7px 50px 7px 20px;
  font-size: 22px;
  cursor: pointer;
  .title {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      right: -22px;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 10px solid #6791aa; /* 三角形颜色 */
    }
    &.active::after {
      transform: translateY(-50%) rotate(180deg);
    }
  }

  .list {
    position: absolute;
    bottom: 70px;
    left: 0;
    width: 1180px;
    height: 0;
    overflow: hidden;
    display: none;
    flex-wrap: wrap;
    background: #f3f7ff;
    box-shadow: 0px 2px 4px 0px rgba(128, 190, 197, 0.43);
    border-radius: 13px;
    border: 1px solid #80bec5;
    transition: height 0.6s;
    z-index: 999;
    li {
      padding: 12px;
      cursor: pointer;
      font-size: 18px;
      width: 25%;
      text-align: center;
      &:hover {
        color: #0fb1c0;
      }
    }
  }
}

.justone {
  width: 100% !important;
  text-align: left !important;
}

.animate1 {
  animation-name: example;
  animation-duration: 0.6s;
  animation-fill-mode: forwards;
}
.animate2 {
  animation-name: example2;
  animation-duration: 0.6s;
  animation-fill-mode: forwards;
}
@keyframes example {
  from {
    height: 0;
  }
  to {
    height: 120px;
  }
}
@keyframes example2 {
  from {
    height: 120px;
  }
  to {
    height: 0;
  }
}
</style>